import axios from 'axios';
import store from '../redux/store/store';

// API URL'si environment değişkenlerinden alınıyor
const API_XML_URL = import.meta.env.VITE_API_URL;

const xmlService = {
  addProductProvider: async (productData, token) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const formattedData = {
        ...productData,
        stockCritical: parseInt(productData.stockCritical, 10), // stockCritical'i int'e çeviriyoruz
        vatRate: parseFloat(productData.vatRate), // vatRate'i decimal'e çeviriyoruz
      };
      const response = await axios.post(
        `${API_XML_URL}/ProductProvider`,
        formattedData,
        {
          headers: {
            Authorization: `Bearer ${userToken}`,
            'Content-Type': 'application/json',
          },
        }
      );

      return response.data;
    } catch (error) {

      console.error("Ürün eklenirken bir hata oluştu:", error);
      if (error.response && error.response.data) {
        console.error("Hata yanıtı:", error.response.data);
      }
      throw error;
    }
  },


  fetchProvider: async () => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get(`/Provider`, { headers: { Authorization: `Bearer ${userToken}` } });
      return response.data;
    } catch (error) {
      console.error('Error fetching invoices:', error);
      throw error;
    }
  },

  fetchProductsProvider: async (userId) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      const response = await axios.get('/ProductProvider', {
        params: {
          withGeneralSettings: true,
          UserId: userId,
          withPriceSettings: true,
          withProvider: true,
          WithNextRun: true
        }
        , headers: { Authorization: `Bearer ${userToken}` }
      });

      return response.data.data;
    } catch (error) {
      console.error('Error fetching invoices:', error);
      throw error;
    }
  },

  fetchRunTimes: async (data) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      // URLSearchParams ile dizi parametrelerini düzgün encode etme
      const params = new URLSearchParams();
      data?.providerIds?.forEach(id => params.append('ProviderIds', id));
      params.append('page', data?.Page);
      const response = await axios.get(`/ProductProviderRuntime?${params.toString()}`, {
        headers: { Authorization: `Bearer ${userToken}` }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching invoices:', error);
      throw error;
    }
  },
  fetchRunTimesLogDetail: async (id) => {
    try {
      const userToken = store.getState()?.auth?.user?.accessToken?.token;
      // URLSearchParams ile dizi parametrelerini düzgün encode etme
      const params = new URLSearchParams();
      params.append('RuntimeId', id);
      const response = await axios.get(`/ProductProviderRuntimeLog?${params.toString()}`, {
        headers: { Authorization: `Bearer ${userToken}` }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching invoices:', error);
      throw error;
    }
  },
}
export default xmlService;
